import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Diseno from '../../components/Diseno';
import SaveData from '../../components/Diseno/SaveData';
import { sagaGetEstilosInterno, sagaGetEstilosOnline, sagaSaveEstilosInterno, sagaSaveEstilosOnline } from '../../reducers/sessionReducer/actions';
import { saveInstalacion } from '../../sagas/sessionSaga/calls';
import { estilosInternoSelector, estilosOnlineSelector, instalacionSelector } from '../../selectors/sessionSelector';

const DisenoContainer = ({ instalacion, estilosInterno, estilosOnline, dispatch }) => {
    const [saveStatus, setSaveStatus] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        dispatch(sagaGetEstilosInterno());
        dispatch(sagaGetEstilosOnline());
    }, [dispatch]);

    const recargarEstilos = () => {
        if (estilosInterno) {
            document.documentElement.style.setProperty('--top-menu-backgroundcolor', estilosInterno.topMenuBackgroundcolor);
            document.documentElement.style.setProperty('--button-primary', estilosInterno.buttonPrimary);
            document.documentElement.style.setProperty('--button-secondary', estilosInterno.buttonSecondary);
            document.documentElement.style.setProperty('--button-secondary-hover', estilosInterno.buttonSecondaryHover);
            document.documentElement.style.setProperty('--button-success', estilosInterno.buttonSuccess);
            document.documentElement.style.setProperty('--button-success-hover', estilosInterno.buttonSuccessHover);
            document.documentElement.style.setProperty('--turnos-itemdia-background', estilosInterno.turnosItemdiaBackground);
            document.documentElement.style.setProperty('--border-config', estilosInterno.borderConfig);
            document.documentElement.style.setProperty('--item-config', estilosInterno.itemConfig);
        }
    };
    
    useEffect(() => {
        console.log('Datos de contacto:', instalacion.datosContacto);
    }, [instalacion])

    useEffect(() => {
        recargarEstilos();
    }, [estilosInterno, estilosOnline]);

    if (!estilosInterno || !estilosOnline || !instalacion) {
        return <div>Cargando...</div>;
    }



    
    const recargarImagenes = () => {
        const imagenes = document.querySelectorAll('img');
        imagenes.forEach(img => {
            if (img) {
                const src = img.src;
                if (src) {
                    const timestamp = new Date().getTime();
                    img.src = `${src.split('?')[0]}?t=${timestamp}`;
                }
            }
        });
    };

    const handleSaveInstalacion = async (instalacionData) => {
        try {
            setLoading(true);
            await saveInstalacion(instalacionData);
            setSaveStatus('success');
        } catch (error) {
            setError(error.message);
            setSaveStatus('error');
        } finally {
            setLoading(false);
        }
        return true;
    };

    const handleSaveEstilos = async (estilosData) => {
        const { internos, online } = estilosData;
        await dispatch(sagaSaveEstilosInterno(internos));
        await dispatch(sagaSaveEstilosOnline(online));
        return true;
    };

    const handleSave = async (instalacionData, estilosData) => {
        try {
            const saveInstalacion = await handleSaveInstalacion(instalacionData);
            const saveEstilos = await handleSaveEstilos(estilosData);

            if (saveInstalacion && saveEstilos) {
                setSaveStatus('success');
                recargarImagenes();
                recargarEstilos();
            } else {
                setSaveStatus('error');
            }
        } catch (error) {
            console.error('Error al guardar:', error);
            setSaveStatus('error');
        }
    };

    const handleClose = () => {
        setSaveStatus(null);
    };

    const footer = {
        correo: instalacion?.datosContacto?.email ?? '',
        telefono: instalacion?.datosContacto?.telefono || '',
        facebook: instalacion?.datosContacto?.facebook || '',
        twitter: instalacion?.datosContacto?.twitter || '',
        instagram: instalacion?.datosContacto?.instagram || '',
        tiktok: instalacion?.datosContacto?.tiktok || '',
        colorPrimario: estilosOnline?.footerBackgroundcolor || '#fff',
        colorSecundario: estilosOnline?.footerDesarrolladoPorBackgroundcolor || '#fff',
        basesYcondiciones: instalacion?.basesYCondiciones || '',
        logoFooter: instalacion?.logoFooter || '',
        logoFooter1: instalacion?.logoFooter1 || '',
        logoFooter2: instalacion?.logoFooter2 || '',
        afipDataFiscalURL: instalacion?.afipDataFiscalURL || '',
    };

    const coloresComponentes = {
        containerTurneroBackground: estilosOnline?.containerTurneroBackground || '#fff',
        containerTurneroBorder: estilosOnline?.containerTurneroBorder || '#fff',
        containerTurneroItemHorario: estilosOnline?.containerTurneroItemHorario || '#fff',
        onlineLinksAndButtons: estilosOnline?.onlineLinksAndButtons || '#fff',
        onlineInformationBoxColor: estilosOnline?.onlineInformationBoxColor || '#f78431',
    }

    const menu = {
        idInstalacion: instalacion.id,
        logoGris: instalacion.ecommerceGreyscale,
        logoPrincipal: instalacion.logoDrawer,
        superiorInterno: estilosInterno.topMenuBackgroundcolor || '#fff',
        superiorOnline: estilosOnline.topMenuBackgroundcolor || '#fff',
        iconoMenu: instalacion.iconoMenu || '',
    };

    const login = {
        logoLoginInterno: instalacion.logoLogin,
        logoLoginOnline: instalacion.fondoLogin,
    };

    const productos = {
        logoProducto: instalacion.logoProducto,
    };

    const emails = {
        logoMail: instalacion.logoMail,
    };

    const mediosPago = {
        noHabilitados: instalacion.mediosPagoNoHabilitados,
        habilitados: instalacion.mediosPagoHabilitados,
        imagenesHabilitados: instalacion.mediosPagoHabilitadosImagenes || [],
        imagenesNoHabilitados: instalacion.mediosPagoNoHabilitadosImagenes || [],
    }

    const textosGenericos = {
        pickup: instalacion.textoGenericoPickup,
        membresia: instalacion.textoGenericoMembresia,
        deliveryBonificado: instalacion.labelDeliveryBonificado || 'Delivery bonificado en compras superiores a ',
        formaPago: instalacion.labelFormaPago || 'Para abonar con Billetera Santa Fe, MODO o Mercado Pago, seleccionar la opción',
        descripcionPickup: instalacion.labelDescripcionPickup || 'retiro del pedido por sucursal',
        descripcionDelivery: instalacion.labelDescripcionDelivery || 'envíos a domicilio',
    }

    return (
        <>
            <Diseno
                onSave={handleSave}
                footer={footer}
                coloresComponentes={coloresComponentes}
                menu={menu}
                login={login}
                productos={productos}
                emails={emails}
                mediosPago={mediosPago}
                textosGenericos={textosGenericos}
            />
            <SaveData
                open={!!saveStatus}
                onClose={handleClose}
                success={saveStatus === 'success'}
            />
        </>
    );
};

const mapStateToProps = (state) => ({
    instalacion: instalacionSelector(state),
    estilosInterno: estilosInternoSelector(state),
    estilosOnline: estilosOnlineSelector(state),
});

export default connect(mapStateToProps)(DisenoContainer);
